import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------
// Seletor de anexos compacto (botão + chips removíveis), espelho do que o app do
// fisco usa (frontend/src/modules/processo-eletronico/components/anexos-input).
// Controlado: o dono guarda os File[] e converte para base64 na hora de enviar
// (utils/ler-base64 → actions/anexos).
// ----------------------------------------------------------------------

function formatBytes(n: number): string {
  if (!n) return '0 B';
  const u = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(u.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i ? 1 : 0)} ${u[i]}`;
}

export function AnexosInput({
  arquivos,
  onChange,
  disabled,
  label = 'Anexar arquivos',
}: {
  arquivos: File[];
  onChange: (arquivos: File[]) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <Stack spacing={1} alignItems="flex-start">
      {!!arquivos.length && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {arquivos.map((a, i) => (
            <Chip
              key={`${a.name}-${i}`}
              size="small"
              variant="soft"
              icon={<Iconify icon="eva:attach-2-fill" width={14} />}
              label={`${a.name} (${formatBytes(a.size)})`}
              onDelete={disabled ? undefined : () => onChange(arquivos.filter((_, j) => j !== i))}
            />
          ))}
        </Stack>
      )}
      <Button
        component="label"
        size="small"
        color="inherit"
        variant="outlined"
        disabled={disabled}
        startIcon={<Iconify icon="eva:attach-2-fill" />}
      >
        {label}
        <input
          type="file"
          hidden
          multiple
          onChange={(e) => {
            const novos = Array.from(e.target.files ?? []);
            if (novos.length) onChange([...arquivos, ...novos]);
            e.target.value = '';
          }}
        />
      </Button>
    </Stack>
  );
}
